export const TEMPLATE_DESIGNS = {
  TYPE_ONE: "type_one",
  TYPE_TWO: "type_two",
  TYPE_THREE: "type_three",
};

export const TEMPLATE_FORMATS = {
  STORY: "story",
  POST: "post",
};

export const TYPE_ONE_CROP_DIMENSIONS = {
  [TEMPLATE_FORMATS.STORY]: { width: 1080, height: 1536 },
  [TEMPLATE_FORMATS.POST]: { width: 1080, height: 945 },
};

export const TEMPLATE_MODE_PALETTE = {
  dark: {
    background: "#0b0b10",
    contrast: "#f5f5f8",
    neutral: "rgba(255, 255, 255, 0.08)",
  },
  light: {
    background: "#f8f8fb",
    contrast: "#16161a",
    neutral: "rgba(0, 0, 0, 0.08)",
  },
};
